import React from 'react';

import { useKlaviyoForms } from 'hooks/useKlaviyoForms';

const KlaviyoWrapper = () => {
  useKlaviyoForms();

  return <></>;
};

export default KlaviyoWrapper;
